import { render, staticRenderFns } from "./Residence.vue?vue&type=template&id=0d7d2b4b&scoped=true"
import script from "./Residence.vue?vue&type=script&lang=js"
export * from "./Residence.vue?vue&type=script&lang=js"
import style0 from "./Residence.vue?vue&type=style&index=0&id=0d7d2b4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7d2b4b",
  null
  
)

export default component.exports